import { FunctionComponent } from 'react'
import { withRecaptcha } from '@lib/mixins/with-recaptcha'
import { RecaptchaConfig } from '@lib/types'
import { noopPromise } from '@lib/utils/noop'
import { RecaptchaContextProvider } from '../../contexts/recaptcha-context'

export const withConditionalRecaptcha = <T extends { structure: { fields: { recaptchaEnabled?: boolean } } }>(
  recaptchaConfig: RecaptchaConfig,
  Component: FunctionComponent<T>
): FunctionComponent<T> => {
  const WithRecaptcha = (props: T) => {
    if (props.structure.fields.recaptchaEnabled) {
      return withRecaptcha(recaptchaConfig, Component)(props)
    }

    return (
      <RecaptchaContextProvider value={noopPromise}>
        <Component {...props} />
      </RecaptchaContextProvider>
    )
  }
  WithRecaptcha.displayName = `withConditionalRecaptcha(${Component.displayName || Component.name || 'Component'})`
  return WithRecaptcha
}
